import moment from 'moment'

class DateHelper {
  static fromNow (date) {
    return moment(date).fromNow()
  }

  // for element-ui date

  static getOptionsAll () {
    return {
    }
  }

  static getOptionsFromToday () {
    return {
      disabledDate (time) {
        let aDay = 1 * (24 * 60 * 60 * 1000)
        return time.getTime() < Date.now() - aDay
      }
    }
  }
}

export default DateHelper
